import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice'
import forgotPasswordReducer from './forgotPasswordSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    changePassword: forgotPasswordReducer
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch